import React, { useRef } from 'react';
import IntegrationsMarquee from './IntegrationsMarquee';
import { useCountUp, useInView } from '../hooks/useCountUp';
import '../styles/TrustBar.css';

interface AnimatedStatProps {
  value: number;
  suffix?: string;
  prefix?: string;
  label: string;
  inView: boolean;
}

const AnimatedStat: React.FC<AnimatedStatProps> = ({ value, suffix = '', prefix = '', label, inView }) => {
  const display = useCountUp(value, inView);
  return (
    <div className="trustbar-stat">
      <div className="trustbar-value gradient-text">
        {prefix}{display.toLocaleString()}{suffix}
      </div>
      <div className="trustbar-sub">{label}</div>
    </div>
  );
};

const TrustBar: React.FC = () => {
  const statsRef = useRef<HTMLDivElement>(null);
  const inView = useInView(statsRef);

  return (
    <section className="trustbar reveal">
      <div className="container trustbar-inner">
        <p className="trustbar-label">Built on the tools your team already uses</p>

        <IntegrationsMarquee />

        <div className="trustbar-stats" ref={statsRef}>
          <AnimatedStat value={50} suffix="+" label="Shipped deployments" inView={inView} />
          <AnimatedStat value={1284000} prefix="" suffix="+" label="Agent actions / month" inView={inView} />
          <AnimatedStat value={3} suffix="×" label="Avg. ROI in first year" inView={inView} />
          <AnimatedStat value={24} suffix="/7" label="Operational coverage" inView={inView} />
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
